import {BaseIconOptions} from 'leaflet';

export const mapIconConfig: BaseIconOptions = {
    iconAnchor: [12, 41],
    iconSize: [32, 32],
    tooltipAnchor: [13, -26],
};
